import * as AccreditationActions from '../../accreditation.actions';
import * as Actions from '../improvement.actions';
import {GRID_FILTER} from '../../../../common/grid/grid.constants';
import moment from 'moment';
import { IDS } from '../improvement-action-id.constants';
import { TYPES } from "../improvement-action-type.constants";
import {TAB_ENABLE, TAB_SELECT, TAB_SHOW} from "../../../../common/tabs/tabs.constants";
import get from "lodash/get";
import {TYPES as ACC_TYPES} from "../../accreditation-action-type.constants";

/**
 * Creates a new ImprovementListController.
 * @class
 */
class ImprovementListController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $uiRouterGlobals,
                $scope,
                $rootScope,
                $filter,
                $timeout,
                $mdDialog,
                $location,
                AuthService,
                Notifier
                ) {

        this.$ngRedux   = $ngRedux;
        this.$state     = $state;
        this.$stateParams = $stateParams;
        this.$uiRouterGlobals = $uiRouterGlobals;
        this.$scope     = $scope;
        this.$rootScope = $rootScope;
        this.$filter    = $filter;
        this.$timeout   = $timeout;
        this.$mdDialog  = $mdDialog;
        this.$location  = $location;
        this.AuthService = AuthService;
        this.Notifier   = Notifier;
        this.identifier = IDS.rcoImprovement;
    }

    $onInit() {
        const user = this.AuthService.getUser();
        this.userType = user.typeCode;
        this.userUuid = user.uuid;
        this.isManager = user.isManager;
        this.unsubscribe = this.$ngRedux.connect(state => {
            const {siteLocation, headOffice, year} = state.accreditation.accDashboardLocationYear;
            return {
                headOffice,
                siteLocation,
                year,
            }
        }, {...AccreditationActions, ...Actions})(this);

        this.unsubscribeLocationChange = this.$scope.$on('LOCATION_SUBJECT_SELECTED', this.onLocationChange.bind(this));

        // this.localizeImprovementGridFilter(this.taskStatuses, this.taskTypes);

        this.$ngRedux.dispatch({
            type: GRID_FILTER,
            id:   IDS.improvementActionsGrid,
            filter: {
                user_uuid: this.userUuid,
                emp_uuid: this.isManager ? undefined : this.userUuid,
                year_start: moment().year() - 1,
                year_end: moment().year() + 2,
            }
        });

        const actionId = this.$uiRouterGlobals?.params?.action_id;
        if (actionId) {
            const ctrl = this;
            this.$timeout(() => {
                ctrl.fetchImprovementActionDetails(actionId).then(item => {
                    ctrl.onSelect({item});
                });
            },200);
        }
    }
    async onLocationChange (evt, loc) {
        const subjectType = get(loc,'in_subject_basic_type_code');

        switch(subjectType) {
            case 'hof':
                this.$ngRedux.dispatch({
                    type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                    accDashboardLocationYear: {
                        headOffice: loc.in_subject_uuid,
                        siteLocation: null,
                    }
                });
                break;

            case 'slo':
                const siteLocation = loc.in_subject_uuid;
                this.$ngRedux.dispatch({
                    type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                    accDashboardLocationYear: {
                        siteLocation: siteLocation,
                    }
                });
                break;
        }
    };

    onSelect({item}){
        this.$ngRedux.dispatch({
            type: TYPES.SET_ACTION_DETAILS,
            id:   IDS.rcoImprovement,
            details: item
        });
        this.$ngRedux.dispatch({
            type: TAB_ENABLE,
            id: IDS.app_accreditation_scheme_improvement,
            state: [
                IDS.app_accreditation_scheme_improvement_action,
                IDS.app_accreditation_scheme_improvement_action_plan,
            ]
        });
        this.$timeout(() => {
            this.$ngRedux.dispatch({
                type: TAB_SELECT,
                id: IDS.app_accreditation_scheme_improvement,
                state: IDS.app_accreditation_scheme_improvement_action,
                stateParams: {
                    action_id: item.uta_id
                },
            });
            setTimeout(() => {
                this.$ngRedux.dispatch({
                    type: GRID_FILTER,
                    id: this.identifier,
                    path: IDS.improvementStepsGrid,
                    filter: {
                        par_id: item.uta_id
                    }
                });
            }, 200);
        });
    }

    onAddImprovementAction(){
        this.$ngRedux.dispatch({
            type: TAB_SHOW,
            id: IDS.app_accreditation_scheme_improvement,
            state: IDS.app_accreditation_scheme_improvement_add_action,
            stateParams: {
                hof: this.headOffice,
                slo: this.siteLocation,
            },
        });
        // this.$timeout(() => {
            // setTimeout(() => {
            //     this.$ngRedux.dispatch({
            //         type: GRID_FILTER,
            //         id: this.identifier,
            //         path: IDS.improvementStepsGrid,
            //         filter: {
            //             par_id: item.uta_id
            //         }
            //     });
            // }, 200);
        // });
    }

    $onDestroy() {
        this.unsubscribe();
        if(this.unsubscribeLocationChange)
            this.unsubscribeLocationChange();
        if (this.dialog)
            this.$mdDialog.hide(this.dialog);
    }
}

ImprovementListController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$uiRouterGlobals',
    '$scope',
    '$rootScope',
    '$filter',
    '$timeout',
    '$mdDialog',
    '$location',
    'AuthService',
    'Notifier',
]

export const improvementActions = {
    bindings: {
    },
    controller: ImprovementListController,
    template: `
        <improvement-actions-grid
            on-select="$ctrl.onSelect($event)">
        </improvement-actions-grid>
        
        <div layout-xs="column" layout-gt-xs="row" layout-align="center center" class="tabs">
            <div flex></div>
            <button type="submit"
                    class="md-button btnColorAccreditations"
                    aria-label="Request Document Revision"
                    ng-click="$ctrl.onAddImprovementAction()">Add Improvement Action
            </button>
        </div>
`,
}
